var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},[_c('h3',[_vm._v("Vehicle : "+_vm._s(_vm.vehicle_plate))]),_c('div',{attrs:{"id":"map"}})])}
var staticRenderFns = []

export { render, staticRenderFns }